import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", location.pathname);
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        setError("Sign-in could not be completed. Please try again.");
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-[#10271a] text-[#f6f1e7] flex items-center justify-center" data-testid="auth-callback">
      <p className="text-sm tracking-[0.2em] uppercase text-[#f6f1e7]/70">{error || "Signing you in..."}</p>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#10271a] text-[#f6f1e7] flex items-center justify-center">
        <p className="text-sm tracking-[0.2em] uppercase text-[#f6f1e7]/70">Checking access...</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
